import { apiClientProtected } from '..'

const route = '/orders'

export default {
  getList(orderType) {
    return apiClientProtected.get(`${route}/${orderType}`)
  },
  submitOrder(tableCode, customerName, dishes) {
    return apiClientProtected.post(route, {
      tableCode,
      customerName,
      dishes
    })
  },
  getOrder(id) {
    return apiClientProtected.get(`${route}/${id}`)
  },
  updateOrder(id, order) {
    return apiClientProtected.put(`${route}/${id}`, order)
  },
  updatePrintedOrder(id) {
    return apiClientProtected.post(`${route}/print/${id}`)
  },
  cancelOrder(id) {
    return apiClientProtected.delete(`${route}/${id}`)
  }
}
